<style lang="scss" scoped>
.destory-update {
    position: relative;
}
.attach-container {
    padding: 20px 40px;
}
.footer-button {
    margin: 0 5px;
}
.modal-desc {
    padding: 20px 0;
    text-align: center;
    font-size: 14px;
}
.modal-button {
    float: right;
}
</style>
<template>
    <div class="destory-update">
        <compWrapper theme="primary" :title="$t('fbb.costmanage.base_info', { defaultValue: '基础信息' })">
            <compFormQuery
                v-if="queryType === 'query'"
                class="margin-layout"
                :formdata="getBase"
                :value="baseInfo"
            ></compFormQuery>
            <slot name="footer" slot="footer" class="zindex-up">

                <Button
                    v-if="baseInfo.moveOrderStatus === 5 ||baseInfo.moveOrderStatus === 10  && this.handleAuth('fbb.warehousemove.approve')"
                    class="footer-button"
                    type="warning"
                    @click="handleOperate(4)"
                    >{{ $t('fbb.alloment.button_audit', { defaultValue: '审核' }) }}</Button
                >
                <Button
                    v-if="queryType === 'query'"
                    class="footer-button"
                    type="error"
                    @click="handleOperate(10)"
                    >{{ $t('fbb.inbound.add_remark', { defaultValue: '添加备注' }) }}</Button
                >
                <Button
                    v-if="baseInfo.moveOrderStatus === 5 ||baseInfo.moveOrderStatus === 10 && this.handleAuth('fbb.warehousemove.complete')"
                    class="footer-button"
                    type="success"
                    @click="handleOperate(5)"
                    >{{ $t('fbb.inventoryadjustment.ignore_complete', { defaultValue: '忽略差异完成' }) }}</Button
                >
                <Button class="footer-button" @click="cancel">{{$t('global.common.return', { defaultValue: '返回' })}}</Button>
            </slot>
        </compWrapper>
        <compWrapper theme="info" :title="$t('global.common.product_info',{defaultValue:'产品信息'})">
            <div class="table-container">
                <Table
                    class="margin-left-40 margin-right-40"
                    :columns="productColumn"
                    :data="productList"
                ></Table>
            </div>
        </compWrapper>
        <compWrapper v-if="queryType === 'query'" theme="gray" :title="$t('global.common.operate_history', { defaultValue: '操作历史' })">
            <Table :columns="logColumn" :data="logList"></Table>
        </compWrapper>
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-close="modalProps.show = false"
            @on-confirm="modalProps.show = false"
        >
            <div class="clearfix" v-if="modalProps.showConfirm">
                <div class="modal-desc">{{ modalProps.desc }}</div>
                <div class="modal-button">
                    <Button
                        class="margin-right-15"
                        type="primary"
                        @click="modalProps.confirm"
                        >{{$t('global.common.update_OK', { defaultValue: '确定' })}}</Button
                    >
                    <Button type="default" @click="modalProps.show = false"
                        >{{$t('global.common.operation_cancel', { defaultValue: '取消' })}}</Button
                    >
                </div>
            </div>
            <component
                v-if="modalProps.component"
                :is="modalProps.component"
                v-bind="modalProps.props"
                @on-close="modalProps.show = false"
                @on-success="modalSuccess"
                v-on="modalProps.on"
            />
        </compModal>
        <Spin v-if="loading" fix size="large"></Spin>
    </div>
</template>

<script>
import compSubmit from "./confirm.vue";
import mixin from "./../mixin";
import { mapState, mapGetters } from "vuex";
import {
    HttpConfirmWarehouseMove,
    HttpMoveItemDetail,
    HttpAddRemark,
    HttpWarehouseMoveDetail,
    HttpGetMoveLog,
    HttpIgnoreComplete
} from "@/service/warehousemove";
export default {
    props: ["type", "id", "state"],
    mixins: [mixin],
    components: {
        compSubmit,
    },
    data() {
        return {
            manage: this.state ? this.state : this.$route.query.state,
            queryType: this.type ? this.type : this.$route.params.type,
            orderId: this.id ? this.id : this.$route.query.id,
            baseInfo: {},
            productInfo: {},
            productCount: {
                totalCount: 0,
                totalVolume: 0,
                totalWeight: 0,
            },
            productList: [],
            selectedIndex: [],
            attachList: [],
            required: {
                required: true,
                message: this.$t('fbb.headlogistics.info_empty', { defaultValue: '请填写必填项' }),
            },
            modalProps: {
                show: false,
                formdata: null,
            },
            attachSelection: [],
            logList: [],
            loading: true,
        };
    },
    watch: {
    },
    created() {
        // console.log(this.queryType, this.orderId);
        // console.log(this.manage, this.getWarehouseList);
        if (this.queryType === "query" || this.queryType === "edit") {
            this.getDetail();
        } else {
            this.loading = false;
        }
    },
    computed: {
        ...mapGetters("dictionary", [
            "getProductList",
            "getWarehouseList",
            "getFilterDisabledWarehouse",
            "getBillcusWareList",
            "getCusproductList",
        ]),
        getBase() {
            console.log(this.baseInfo);
            console.log(this.baseInfo.inOrgWarehouseId);
            console.log(1111);
            return [
                {
                    label: this.$t('fbb.warehousemove.move_order_no', { defaultValue: "库存移库单号" }),
                    key: "moveOrderNo",
                    show: this.queryType === "query",
                },
                {
                    label: this.$t('global.common.status', { defaultValue: "状态" }),
                    key: "moveOrderStatus",
                    options: this.getInventoryAdjustmentStatus,
                    show: this.queryType === "query",
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key:
                        this.state === 1
                            ? "orgWarehouseCode"
                            : "orgWarehouseId",
                    options: this.getWarehouseList,
                    show: this.queryType === "query",
                },
                {
                    label: this.$t('fbb.alloment.warehouse_in', { defaultValue: "入库仓库" }),
                    key:
                        this.state === 1
                            ? "inOrgWarehouseCode"
                            : (this.baseInfo.inOrgWarehouseId === 0? "--": "inOrgWarehouseId"),
                    options: this.getWarehouseList,
                    show: this.queryType === "query",
                },
                {
                    label: this.$t('global.common.source_number', { defaultValue: '来源单号' }),
                    key: "sourceNo",
                    tag: "vInput",
                    required: false,
                },
                {
                    label: this.$t('global.common.ref_no', { defaultValue: "关联单据号" }),
                    key: "refNo",
                    tag: "vInput",
                    required: false,
                },
                {
                    label: this.$t('fbb.costmanage.work_type', { defaultValue: "业务类型" }),
                    key: "type",
                    options: this.getAdjustmentBusinessType,
                    show: this.queryType === "query",
                },
                {
                    label: this.$t('global.common.notes', { defaultValue: '备注' }),
                    key: "remark",
                    tag: "vTextarea",
                    required: false,
                },
            ];
        },
        productColumn() {
            let columns = [
                {
                    type: "index",
                    title: "No.",
                    width: 60,
                    align: "center",
                },
                {
                    title: "SKU",
                    key: "sku",
                },

                {
                    title: this.$t('fbb.costmanage.work_type', { defaultValue: "库存类型" }),
                    key: "inventoryType",
                    render:(h,{row})=>{
                        return <div>
                        {row.inventoryType == 0 ? this.$t('fbb.inbound.available_stock', { defaultValue: '可售库存' }) : this.$t('fbb.inbound.unavailable_stock', { defaultValue: '不可售库存' })}
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.inventoryadjustment.adjustment_qty', { defaultValue: "调整数量" }),
                    key: "qty",
                },
                {
                    title: this.$t('fbb.inventoryadjustment.processed_qty', { defaultValue: "已处理数量" }),
                    key: "qtyDone",
                },
                {
                    title: this.$t('fbb.common.product_size', { defaultValue: '长*宽*高' }) + '（cm）',
                    render: (h, { row }) => {
                        return (
                            <div>
                                {row.length} * {row.width} * {row.height}
                            </div>
                        );
                    },
                },
                {
                    title: this.$t('global.common.weight', { defaultValue: '重量' })+ '（g）',
                    key: "weight",
                },
            ];
            if (this.queryType !== "query") {
                // 增加最左侧选框
                columns.unshift({
                    type: "selection",
                    width: 60,
                    align: "center",
                });
                // 编辑、新增时去除销毁数
                columns.splice(5, 1);
            }
            return columns;
        },
        logColumn() {
            return [
                {
                    type: "index",
                    title: "No.",
                    width: 60,
                    align: "center",
                },
                {
                    title: this.$t('global.common.operate_type', { defaultValue: '操作类型' }),
                    // width: 100,
                    render: (h, { row }) => {
                        let label = this.operateTypeList.filter((item) => {
                            return item.value === row.operateType;
                        })[0].label;
                        return <div>{label}</div>;
                    },
                },
                {
                    title: this.$t('global.common.operator', { defaultValue: '操作人' }),
                    key: "createdName",
                    // width: 100,
                },
                {
                    title: this.$t('global.common.notes', { defaultValue: '备注' }),
                    key: "remark",
                },
                {
                    title: this.$t('global.common.operate_time', { defaultValue: "操作时间" }),
                    key: "updatedAt",
                    width: 200,
                },
            ];
        },
    },
    methods: {
        /**
         * 操作成功更新
         */
        modalSuccess(refresh) {
            if (!refresh) {
                this.getDetail();
            }
        },
        async getDetail() {
            this.loading = true;
            // 基础信息
            await HttpWarehouseMoveDetail({
                id: this.orderId,
            }).then(
                (res) => {
                    // console.log(res);
                    this.baseInfo = res.data;
                    // console.log(this.baseInfo);
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            if (this.queryType === "query") {
                await this.getLog();
            }
            // sku列表
            await HttpMoveItemDetail({
                id: this.orderId,
            }).then(
                (res) => {
                    console.log(res.data)
                    // console.log(res);
                    this.productList = res.data;
                },
                (err) => {}
            );

            this.loading = false;
        },
        async getLog() {
            await HttpGetMoveLog({
                page: 1,
                rows: 1000,
                sidx: "id",
                sord: "desc",
                "search[EQ_orderId]": this.baseInfo.id,
                "search[EQ_orderType]": 720,
            }).then(
                (res) => {
                    // console.log(res);
                    this.logList = res.data.content;
                },
                (err) => {
                    this.$VMessage.error(err);
                }
            );
        },
        /**
         * 处理按钮操作
         */
        async handleOperate(type) {
            let operate =
                this.operateTypeList.filter((item) => {
                    return item.value === type;
                })[0] || {};
            if (!operate) return;
            operate = operate.label;
            this.modalShow({}, operate, type);
        },
        cancel() {
            this.$emit("on-close");
        },
        modalShow(otherParams = {}, title, type, success) {
            console.log(this.baseInfo.moveOrderNo);
            this.modalProps = {
                show: true,
                title: title,
                showFooter: false,
                width: 600,
                props: {
                    otherParams,
                    id: this.orderId,
                    orderNo: this.baseInfo.moveOrderNo,
                    type: type,
                    success: success,
                },
                component: "compSubmit",
                "on-cancel": () => {
                    this.modalProps.show = false;
                },
            };
        },
        /**
         * 操作成功
         */
        operateSuccess() {
            this.$emit("on-update");
            this.$router.push({
                name: "destoryPlan",
            });
        },
    },
};
</script>

<style>
</style>
